import * as React from 'react';

function SvgProgressLandlordPreApprovalFailed(props) {
  return (
    <svg viewBox="0 0 21 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.596 18.665C2.2 18.615 0 18.258 0 17.255c0-4.54 4.103-8.205 9.15-8.205a10.1 10.1 0 012.982.445 6.97 6.97 0 00-1.921.918 8.975 8.975 0 00-1.061-.063c-4.2 0-7.635 2.907-7.84 6.56.06.015.127.031.202.047.42.087 1.047.164 1.846.228 1.069.085 2.416.144 3.887.17.075.453.194.891.351 1.31zM9.15 10.4a5.2 5.2 0 110-10.4 5.2 5.2 0 010 10.4zm0-1.4a3.8 3.8 0 100-7.6 3.8 3.8 0 000 7.6zm5.286 1.771a5.714 5.714 0 100 11.429 5.714 5.714 0 000-11.429zm1.051 5.747l1.308-1.308a.65.65 0 10-.92-.92l-1.306 1.31-1.309-1.31a.65.65 0 10-.92.92l1.309 1.308-1.309 1.308a.65.65 0 10.92.92l1.308-1.309 1.308 1.308a.65.65 0 10.92-.92l-1.309-1.307zm-1.051 4.25a4.284 4.284 0 110-8.567 4.284 4.284 0 010 8.568z" />
    </svg>
  );
}

export default SvgProgressLandlordPreApprovalFailed;
